import React from 'react';
import {
  FileText,
  LogOut,
  User,
  Book,
  HelpCircle,
  FileQuestion,
  Home,
  BarChart2,
  Users,
  ShieldAlert
} from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import logo from '../logo.png';

const NavBar = ({ user, setCurrentPage }) => {
  const handleLogout = () => signOut(auth);
  
  const navItems = [
    { id: 'AdminHomePage', label: 'Home', icon: <Home size={20} /> },
    { id: 'home', label: 'Question Upload', icon: <FileQuestion size={20} /> },
    { id: 'TheoryDashboard', label: 'Theory', icon: <Book size={20} /> },
    { id: 'SamplePaperUpload', label: 'Sample Papers', icon: <FileText size={20} /> },
    { id: 'ExploreDataDashboard', label: 'Explore Data', icon: <BarChart2 size={20} /> },
    { id: 'MembershipManagement', label: 'Membership', icon: <Users size={20} /> },
    { id: 'UnregisteredAccessPanel', label: 'Unregistered Access', icon: <ShieldAlert size={20} /> }
  ];
  
  return (
    <nav className="fixed top-0 w-full bg-white shadow-md z-10">
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center py-3">
        <div className="flex items-center space-x-4">
          {/* Logo */}
          <img
            src={logo}
            alt="Logo"
            className="h-8 w-8 cursor-pointer"
            onClick={() => setCurrentPage('home')}
          />
          
          {/* Navigation Menu */}
          <div className="flex items-center space-x-1 overflow-x-auto scrollbar-hide">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => setCurrentPage(item.id)}
                aria-label={item.label}
                className="flex items-center px-2 py-1.5 hover:bg-gray-100 rounded-md transition-colors"
              >
                <div className="text-gray-700 hover:text-blue-600">{item.icon}</div>
                <span className="ml-1.5 text-sm hidden sm:inline whitespace-nowrap">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
        
        {/* User Profile & Logout */}
        <div className="flex items-center space-x-4">
          {user && (
            <div className="flex items-center">
              <div className="hidden md:block text-sm font-medium text-gray-700 mr-2">
                {user.displayName || user.email}
              </div>
              {user.photoURL ? (
                <img
                  src={user.photoURL}
                  alt="Profile"
                  className="h-8 w-8 rounded-full border border-gray-200"
                />
              ) : (
                <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
                  <User size={18} className="text-blue-600" />
                </div>
              )}
            </div>
          )}
          <button 
            onClick={handleLogout}
            aria-label="Logout"
            className="p-1.5 hover:bg-red-50 hover:text-red-600 rounded-md transition-colors"
            title="Logout"
          >
            <LogOut size={20} className="text-gray-700 hover:text-red-600" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;